export default __webpack_public_path__ + "static/notion-2-bffbc5b907d57fd4f159b1add4616996.png";